import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';

export const SettingsLayoutHeader = ({ title, description, actions, sx }) => (
  <Flex
    as="header"
    pb="16px"
    alignItems="center"
    sx={{ borderBottom: 1, borderBottomColor: 'border.subtle', gap: '16px', ...sx }}
  >
    <Flex
      alignItems={['flex-start', 'flex-start', 'center']}
      justifyContent="space-between"
      flexWrap="wrap"
      width="100%"
      flexDirection={['column', 'column', 'row']}
      sx={{ gap: '8px' }}
    >
      <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
        <Box as="h1" fontSize="18px" fontWeight="semibold" color="text.dark">
          {title}
        </Box>
        <Text fontSize="14px">{description}</Text>
      </Flex>
      {!!actions.length && (
        <Flex alignItems="center" sx={{ gap: '8px' }}>
          {actions.map((action) => action)}
        </Flex>
      )}
    </Flex>
  </Flex>
);

SettingsLayoutHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.array,
  sx: PropTypes.object,
};

SettingsLayoutHeader.defaultProps = {
  description: '',
  actions: [],
  sx: {},
};
